var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useStore } from "effector-react";
import { classNames } from "../util/common-utilities";
import SiteStore from "../stores/SiteStore";
export default function CookieWarning(props) {
    var _a = useState(false), cookieshow = _a[0], cookieshowSet = _a[1];
    var site_store = useStore(SiteStore);
    useEffect(function () {
        var queryParams = new URLSearchParams(window.location.search);
        if (!queryParams.get("success") && !queryParams.get("error") && site_store.geoInfo.region === "CA") {
            cookieshowSet(true);
        }
    }, [site_store.geoInfo]);
    return (_jsx(_Fragment, { children: _jsxs("footer", __assign({ className: classNames(cookieshow &&
                ["INIT", site_store.quickLoadMode && !(props === null || props === void 0 ? void 0 : props.initOnly) ? "QUIZ" : ""].includes(site_store.state)
                ? "block"
                : "hidden", "w-full fixed inset-x-0 bottom-0 py-4 bg-black bg-opacity-70 text-center") }, { children: [_jsx("p", __assign({ className: classNames("hidden text-white font-bold p-0 m-0", "xs:block") }, { children: "This website uses cookies." }), void 0), _jsxs("div", __assign({ className: classNames("text-xs text-white justify-center mx-auto", "xs:text-sm") }, { children: ["By using our site, you acknowledge that you have read and understand our", " ", _jsx("a", __assign({ href: "https://policies.reliancelitigation.com/cookie/", rel: "noreferrer", target: "_blank", className: classNames("underline") }, { children: "cookie policy" }), void 0), ".", " ", _jsx("button", __assign({ onClick: function () {
                                cookieshowSet(false);
                            }, className: classNames("border-2 bg-blue-700 ml-6 text-xs py-1 px-1 m-1", "xs:p-2 xs:ml-2") }, { children: "Got It!" }), void 0)] }), void 0)] }), void 0) }, void 0));
}
